import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import {
  Http,
  RequestOptions,
  Headers,
  RequestOptionsArgs
} from "@angular/http";
import { Storage } from "@ionic/storage";
import { ConfigurationService } from "ionic-configuration-service";

export class User {
  name: string;
  email: string;

  constructor(name: string, email: string) {
    this.name = name;
    this.email = email;
  }
}

@Injectable()
export class AuthService {
  currentUser: User;
  continue: boolean;
  global_data: any;

  constructor(
    private configurationService: ConfigurationService,
    public http: Http,
    public storage: Storage
  ) {
    console.log("auth-service started");
    this.continue = false;
    this.global_data = new Map();
  }

  public get_filers_items(propertyName: any, value?: any, label?: any) {
    let x = JSON.parse(localStorage.getItem("fuFilters"));

    if (!value) {
      value = "value";
      label = "value";
    }

    console.log(x);
    let y = x[propertyName];
    console.log(y);

    let filerArray = [];
    for (var i = y.length - 1; i >= 0; i--) {
      filerArray.push({ label: y[i][label], value: y[i][value] });
    }
    return filerArray;
  }

  public get_data(end_point) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });

        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
              "api/v0.2/" +
              end_point,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      }); //jwt_promise end
    });
  }

  public set_item(item_key, item_val) {
    let item_key_name = item_key;
    this.global_data.set(item_key_name, item_val);
  }

  public get_item(item_key) {
    return this.global_data.get(item_key);
  }

  public async login(credentials) {
    return new Promise(resolve => {
      this.http
        .post(
          this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/auth",
          { username: credentials.email, password: credentials.password }
        )
        .map(res => res.json())
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  public getUserInfo(): User {
    return this.currentUser;
  }

  public logout() {
    return Observable.create(observer => {
      this.currentUser = null;
      observer.next(true);
      observer.complete();
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth-service.ts